<template>
  <div class="domaine-container">

    <div class="header-container">
      <div class="header">
        <div class="navbar">
          <app-accueil-navbar @toggleMenu="toggleMenuTwo" :open="menuShowed"></app-accueil-navbar>
        </div>

        <div class="image-header">
          <div class="header-content">
            <div class="space"></div>
            <h1>Découvrez ce que <br><span>nous proposons</span></h1>
            <div class="background-blue">
              <p>CYBERDINE CONSEIL vous accompagne pour vous apporter souplesse et</p>
              <p>flexibilité dans la gestion des ressources de vos projets.</p>
              <div class="barre-vertical"></div>
              <div class="barre-vertical-2"></div>
            </div>
          </div>
        </div>

        <transition name="size-menu">
          <app-accueil-hamburger v-if="this.menuShowed"></app-accueil-hamburger>
        </transition>

        <transition name="opacity">
          <div class="shadow" v-if="this.menuShowed" @click="toggleMenuTwo"></div>
        </transition>
      </div>

    </div>

      <div class="content flex-column">
        <div class="titre flex-row-space-evenly">
          <h2>Centre de service</h2>
          <img src="../../img/domaine_activite/triangle.svg" alt="">
        </div>

        <div class="texte-container flex-row-space-evenly">
          <div class="image-float">
            <app-image-float>
              <template slot="fond"><img src="../../img/services/element_graphique_services.svg" alt=""></template>
              <template slot="float-image"><img src="../../img/services/service_image_centre_de_service.png" alt=""></template>
            </app-image-float>
          </div>
          <div class="texte">
            <div class="technique">
              <div class="trait"></div>
              <span>Forfait</span>
            </div>
            <p>A la différence de l’assistance technique, le forfait permet au client de s’affranchir des problématiques de gestion interne du projet qu’il souhaite externaliser.</p>
            <p>Le cadre du forfait implique une obligation de résultats et une gestion autonome des moyens mis en œuvre par le fournisseur. Les engagements portent sur des livrables définis au préalable et des délais de livraisons établis.</p>
            <p>Le cadre du forfait implique une obligation de résultats et une gestion autonome des moyens mis en œuvre par le fournisseur. Les engagements portent sur des livrables définis au préalable et des délais de livraisons établis.</p>
            <b>Vous avez un projet ? Laissez-nous les clés on s’en occupe !</b>
          </div>
        </div>
      </div>

    <div class="technique-services">
      <app-technique-services></app-technique-services>
    </div>

    <div class="domaine">
      <app-domaine-activite></app-domaine-activite>
    </div>

    <app-contact></app-contact>

    <app-footer></app-footer>
  </div>
</template>

<script>
    import { menuBus } from '../../main';

    import Navbar from "./Navbar";
    import Footer from "../Footer";
    import HamburgerMenu from "../accueil/HamburgerMenu";
    import Contact from "../accueil/Contact";
    import DomaineActivite from "../accueil/DomaineActivite";
    import TechniqueService from "../accueil/TechniqueService";
    import ImageFloat from "./ImageFloatServices";

  export default {
      data() {
          return {
              menuShowed: false
          }
      },
      methods: {
        toggleMenuTwo() {
            this.menuShowed = !this.menuShowed;
            if (this.menuShowed) {
                document.getElementsByTagName('body')[0].classList.add('blocked');
            }
            else {
                document.getElementsByTagName('body')[0].classList.remove('blocked');
            }
        }
      },
      mounted() {
          menuBus.$on('changePage', (pageName, idName) => {
              this.menuShowed = false;
          });
      },
    components: {
        'app-accueil-navbar': Navbar,
        'app-footer': Footer,
        'app-contact': Contact,
        'app-accueil-hamburger': HamburgerMenu,
        'app-domaine-activite': DomaineActivite,
        'app-technique-services': TechniqueService,
        'app-image-float': ImageFloat,
    }
  }
</script>

<style scoped>
  .technique-services {
    z-index: 100;
  }
  .domaine {
    z-index: 10;
    overflow-y: hidden;
  }

  .header-container {
    z-index: 100;
  }

  .header {
    position: relative;
    height: 100vh;
    min-height: 600px;
  }
  .navbar {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 100;
  }

  .image-header {
    position: absolute;
    height: 100vh;
    min-height: 650px;
    width: 100%;

    background: url("../../img/services/reduct/reduct_en_tete_service_filtre.jpg") no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  .image-header .space {
    height: 200px;
  }
  .image-header .header-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateY(-50%) translateX(-50%);
    width: calc(100% - 150px);
    text-align: left;
  }
  .image-header h1 {
    z-index: 10;

    font-size: 100px;
    color: white;
    font-weight: 900;
    line-height: 0.9;

    text-align: center;
  }
  .image-header h1 span {
    color: #9fa8bd;
  }
  .image-header p {
    margin: 0;
    color: white;
    font-weight: 300;
    font-size: 30px;

    text-align: center;
  }
  .background-blue {
    background-color: rgba(22, 33, 57, 0.6);
    padding: 20px;
    width: fit-content;
    position: relative;
    margin: 0 auto;
  }
  .barre-vertical {
    width: 2px;
    height: calc(100% + 40px);
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #dfe8ff;
  }
  .barre-vertical-2 {
    width: 2px;
    height: calc(100% + 40px);
    position: absolute;
    top: 0;
    left: 0;
    background-color: #dfe8ff;
  }

  .content .titre {
    height: 230px;
    width: 100%;
    position: relative;
    margin-bottom: 20px;
  }
  .content .titre h2 {
    text-transform: uppercase;
    font-weight: 900;
    color: #162139;
    font-size: 60px;
    margin-top: 70px;
  }
  .content .titre img {
    position: absolute;
    bottom: 0;
    height: 30px;
  }
  .content .texte-container {
    padding-bottom: 100px;
  }
  .content .texte-container > * {
    width: 50%;
  }
  .content .texte-container img {
    max-height: 500px;
  }
  .content .texte-container .texte {
    text-align: left;
    margin-top: 100px;
  }
  .content .texte-container .texte .technique {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 50px;
  }
  .content .texte-container .texte .technique .trait {
    height: 7px;
    width: 70px;
    background-color: #b7e17e;
    margin-right: 10px;
  }
  .content .texte-container .texte .technique span {
    font-size: 25px;
    color: #b7e17e;
    text-transform: uppercase;
    font-weight: 900;
  }
  .content .texte-container .texte p {
    font-size: 20px;
    color: #9fa8bd;
    font-weight: 300;
    line-height: 1.5;
    margin: 0;
    text-align: left;
    width: 80%;
  }
  .content .texte-container .texte b {
    font-size: 20px;
    color: #9fa8bd;
    line-height: 1.5;
    margin: 0;
    text-align: left;
    width: 80%;
  }

  .space {
    height: 0!important;
  }

  /* Tablet */
  @media (max-width: 1000px) {
    .image-header h1 {
      font-size: 60px;
    }
    .image-header p {
      font-size: 25px;
    }

    .image-float {
      height: 80%;
      width: 50%;
      max-height: 640px;
      max-width: 625px!important;
    }

    .image-header .header-content {
      width: calc(100% - 50px);
    }

    .texte-container {
      flex-direction: column;
    }
    .content .texte-container > * {
      width: calc(100% - 100px);
    }
    .content .texte-container .texte {
      margin-left: 100px;
    }
  }

  /* Mobile */
  @media (max-width: 600px) {
    .image-header h1 {
      font-size: 35px;
    }
    .image-header p {
      font-size: 15px;
    }
    .space {
      height: 100px!important;
    }
    .content .texte-container .texte {
      margin-left: 50px;
    }
    .content .titre h2 {
      font-size: 40px;
    }
  }
  @media (max-width: 550px) {

  }
  @media (max-width: 400px) {

  }

  .size-menu-enter-active,
  .size-menu-leave-active {
    transition: all 0.5s;
    max-height: 500px!important;
  }
  .size-menu-enter,
  .size-menu-leave-to
  {
    opacity: 0;
    max-height: 0px!important;
  }

  .shadow {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 60;
    position: fixed;
  }

  .opacity-enter-active,
  .opacity-leave-active {
    transition: all 0.5s;
  }
  .opacity-enter,
  .opacity-leave-to
  {
    opacity: 0;
  }

  @media (min-width: 1100px) {
    .shadow {
      display: none!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/services/CentreService.vue